
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class BookingTimePreview extends Vue {
  @Prop() readonly hour: string;
  @Prop() readonly minute: string;
  @Prop() readonly active_hour: boolean;
  @Prop() readonly active_minute: boolean;

  get showHour(): string {
    return this.hour ? this.hour.padStart(2, '0') : '--';
  }

  get showMinute(): string {
    return this.minute ? this.minute.padStart(2, '0') : '--';
  }

  selectedHour(): void {
    this.$emit('click');
  }
}
